import { injectable } from 'tsyringe';
import { HttpClientApi } from '@/modules/http-client/public/api';

import type { WhatsAppSignupConfigRepository } from '@/modules/settings/domain/channels/WhatsAppSignupConfigRepository';
import { WhatsAppSignupConfig } from '@/modules/settings/domain/channels/WhatsAppSignupConfig';
import type { HttpWhatsAppSignupConfig } from '@/modules/settings/adapters/channels/HttpWhatsAppSignupConfig';

@injectable()
export class HttpWhatsAppSignupConfigRepository implements WhatsAppSignupConfigRepository {
  constructor(private readonly httpClient: HttpClientApi) {}

  async get(): Promise<WhatsAppSignupConfig> {
    const data = await this.httpClient.get<HttpWhatsAppSignupConfig>(
      '/api/v0/facility/{facilityId}/whatsapp/signup-config',
    );

    return new WhatsAppSignupConfig(data.metaAppId, data.metaConfigId, data.solutionId ?? '');
  }
}
